import Vue from 'vue'
import Router from 'vue-router'

import Player from '@/views/Player'
import Preview from '@/views/Preview'
import Wrapper from '@/views/Wrapper'
import Verify from "@/views/Verify";
import Default from "@/views/Default";
import Off from "@/views/Off";

// Views - Pages
const Page403 = () => import('@/views/pages/Page403')
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')

Vue.use(Router)

let router = new Router({
  base: process.env.NODE_ENV === 'development' ? '/' : '/',
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      name: 'Wrapper',
      component: Wrapper,
      children: [
        {
          path: 'verify.html',
          name: 'verify',
          component: Verify
        },
        {
          path: 'player.html',
          name: 'player',
          component: Player
        },
        {
          path: 'default.html',
          name: 'Default',
          component: Default,
        },
        {
          path: 'off.html',
          name: 'Off',
          component: Off,
        },
      ]
    },
    {
      path: '/preview.html',
      name: 'preview',
      component: Preview
    },
    {
      path: '/errors',
      // redirect: '/errors/404',
      name: 'errors',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '403',
          name: 'page403',
          component: Page403
        },
        {
          path: '404',
          name: 'page404',
          component: Page404
        },
        {
          path: '500',
          name: 'page500',
          component: Page500
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: Page404,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js